/**
 * @generated SignedSource<<68b84f83ed45b3aa1ae779da150af3ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MenuItemTooltip_useGetPropsForExternalWorkspaces_note$data = {
  readonly stream: {
    readonly account: {
      readonly name: string;
    };
    readonly isExternal: boolean;
  };
  readonly " $fragmentType": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note";
};
export type MenuItemTooltip_useGetPropsForExternalWorkspaces_note$key = {
  readonly " $data"?: MenuItemTooltip_useGetPropsForExternalWorkspaces_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "d20cf83bbd26a60c8ee03d500c26f073";

export default node;
